import { MenuItem, Stack, TextField } from '@mui/material';
import { PHONE_DIAL_CODES } from '@utils/countries';

interface PhoneWithDialCodeProps {
  iso: string;
  local: string;
  onIsoChange: (iso: string) => void;
  onLocalChange: (local: string) => void;
  error?: boolean;
  helperText?: string;
}

const PhoneWithDialCode = ({
  iso,
  local,
  onIsoChange,
  onLocalChange,
  error,
  helperText,
}: PhoneWithDialCodeProps) => (
  <Stack direction="row" spacing={1} alignItems="flex-start">
    <TextField
      select
      label="Code"
      value={iso || 'IN'}
      onChange={(e) => onIsoChange(e.target.value)}
      sx={{
        width: 108,
        flexShrink: 0,
        '& .MuiSelect-select': {
          fontWeight: 700,
          fontSize: '0.8rem',
          py: 1.67,
        },
      }}
      SelectProps={{
        renderValue: (value) => {
          const opt = PHONE_DIAL_CODES.find((c) => c.iso === value);
          return opt ? `${opt.iso} ${opt.dial}` : String(value);
        },
        MenuProps: {
          PaperProps: { sx: { maxHeight: 320 } },
        },
      }}
    >
      {PHONE_DIAL_CODES.map((opt) => (
        <MenuItem key={opt.iso} value={opt.iso} sx={{ fontSize: '0.875rem' }}>
          {opt.iso} {opt.dial} · {opt.country}
        </MenuItem>
      ))}
    </TextField>
    <TextField
      label="Phone (optional)"
      value={local}
      onChange={(e) => onLocalChange(e.target.value.replace(/[^\d\s-]/g, ''))}
      fullWidth
      type="tel"
      inputMode="tel"
      autoComplete="tel-national"
      error={error}
      helperText={helperText || ' '}
    />
  </Stack>
);

export default PhoneWithDialCode;
